import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Donate.css';

function Donate() {
  const [copiedCrypto, setCopiedCrypto] = useState<string | null>(null);
  const navigate = useNavigate();

  const cryptoAddresses = {
    BTC: 'bc1qhxvt400pvlz047g6vnk4ej8yaexlppzszxap0a',
    ETH: '-- SOON --',
    XMR: '-- SOON --',
  };

  const copyAddress = async (currency: string, address: string) => {
    try {
      await navigator.clipboard.writeText(address);
      setCopiedCrypto(currency);
      setTimeout(() => setCopiedCrypto(null), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <div className="donate-page">
      <div className="donate-content">
        <h1>Support ZeroTrace</h1>
        <p className="donate-description">
          ZeroTrace is a free service that helps people communicate securely and privately. 
          Your support helps us keep this service running and completely free for everyone.
        </p>
        
        <div className="crypto-list">
          {Object.entries(cryptoAddresses).map(([currency, address]) => (
            <div key={currency} className="crypto-item">
              <span className="crypto-currency">{currency}</span>
              <div className="crypto-address">
                <code>{address}</code>
                <button 
                  onClick={() => copyAddress(currency, address)}
                  className="copy-address-button"
                >
                  {copiedCrypto === currency ? 'Copied!' : 'Copy'}
                </button>
              </div>
            </div>
          ))}
        </div>

        <button onClick={() => navigate('/')} className="back-button">
          Back to Home
        </button>
      </div>
    </div>
  );
}

export default Donate; 